import { CustomerBrowserData } from '@up/data';

export class BillingAuthorizeInvoiceDto {
  invoiceId?: number;
  merchantGroupId?: number;
  customerBrowserData?: CustomerBrowserData;
  userId?: number;
}
